import TextInput from 'components/TextInput'

interface KitIdInputProps {
  name: string
}

const KitIdInput = (props: KitIdInputProps) => {
  return <TextInput name={props.name} label="Kit ID" />
}

export default KitIdInput
